import Store from "../store/store";
import ServicoBuscaSession from "./servicoBuscaSession";

let chavePreparada = null;
let preparacaoPendente = null;
let chavePendente = null;

function carregarSdk() {
    if (document.getElementById("servico-busca-sdk")) {
        return;
    }

    const script = document.createElement("script");
    script.id = "servico-busca-sdk";
    script.src = process.env.VUE_APP_SERVICO_BUSCA_SCRIPT;
    script.async = true;
    script.addEventListener("load", () => {
        console.info("[ServicoBusca] Script carregado do CDN.", { src: script.src });
    });
    script.addEventListener("error", () => {
        console.error("[ServicoBusca] Falha ao carregar o script do CDN.", { src: script.src });
        chavePreparada = null;
        script.remove();
    });
    document.body.appendChild(script);
}

function preparar() {
    const chave = Store.state.login.xApiKey;
    if (!chave) {
        return Promise.reject(new Error("Chave de acesso indisponivel para o ServicoBusca."));
    }

    if (chavePreparada === chave && document.getElementById("servico-busca-sdk")) {
        return ServicoBuscaSession.obterContexto().then(() => {});
    }

    if (preparacaoPendente && chavePendente === chave) {
        return preparacaoPendente;
    }

    if (chavePreparada && chavePreparada !== chave && document.getElementById("servico-busca-sdk")) {
        window.location.reload();
        return Promise.reject(new Error("Recarregando o SDK para a revenda selecionada."));
    }

    let promessa = ServicoBuscaSession.preparar().then(() => {
        if (Store.state.login.xApiKey !== chave) {
            throw new Error("A revenda foi alterada durante a preparacao do ServicoBusca.");
        }

        chavePreparada = chave;
        carregarSdk();
    }).catch((error) => {
        if (Store.state.login.xApiKey === chave) {
            ServicoBuscaSession.remover();
        }
        return Promise.reject(error);
    }).then((resultado) => {
        if (preparacaoPendente === promessa) {
            preparacaoPendente = null;
            chavePendente = null;
        }
        return resultado;
    }, (error) => {
        if (preparacaoPendente === promessa) {
            preparacaoPendente = null;
            chavePendente = null;
        }
        return Promise.reject(error);
    });

    preparacaoPendente = promessa;
    chavePendente = chave;
    return preparacaoPendente;
}

export default { preparar };
